/* eslint-disable no-template-curly-in-string */
module.exports = {
  validationMessagesTranslation: {
    mixed: {
      default: '${path} é inválido',
      required: 'Este campo é obrigatório',
      oneOf: '${path} deve ser um dos seguintes valores: ${values}',
      notOneOf: '${path} não pode ser um dos seguintes valores: ${values}',
    },
    string: {
      length: 'Deve ter ${length} caracteres',
      min: 'Deve ter pelo menos ${min} caracteres',
      max: 'Deve ter no máximo ${max} caracteres',
      email: 'Deve ser um formato válido de e-mail',
      url: '${path} deve ter um formato de URL válida',
      trim: '${path} não deve conter espaços no início ou no fim.',
      lowercase: '${path} deve estar em maiúsculo',
      uppercase: '${path} deve estar em minúsculo',
      matches: 'Deve ser ...',
    },
    number: {
      min: '${path} deve ser no mínimo ${min}',
      max: '${path} deve ser no máximo ${max}',
      lessThan: '${path} deve ser menor que ${less}',
      moreThan: '${path} deve ser maior que ${more}',
      notEqual: '${path} não pode ser igual à ${notEqual}',
      positive: 'Deve ser um número posítivo',
      negative: '${path} deve ser um número negativo',
      integer: '${path} deve ser um número inteiro',
    },
    date: {
      min: '${path} deve ser maior que a data ${min}',
      max: '${path} deve ser menor que a data ${max}',
    },
    array: {
      min: 'Deve ter no mínimo ${min} item',
      max: 'Deve ter no máximo ${max} itens',
    },
  },
};
